// @flow
import Debug from 'debug';
import EventEmitter from 'events';
import ioClient from 'socket.io-client';
import environmentLoader from '../utils/environmentLoader';
import getAuthorizationToken from '../utils/getAuthorizationToken';
import firebase from './firebase';

const config = environmentLoader.load('config');
if(!config) {
    throw new Error('Config is undefined');
}

const debug = Debug('amms:services:tis');
const rtDebug = Debug('rt:amms:services:tis');

class Tis extends EventEmitter {
    constructor() {
        super();
        this.token = null;
        this.unsubscribe = null;
    }

    enable() {
        debug('Tis enabled');

        if(!this.unsubscribe) {
            debug('Subscribing to user state changes');

            this.unsubscribe = firebase.auth().onIdTokenChanged((user) => {
                debug('User state change: ', user);
                if(user) {
                    getAuthorizationToken()
                        .then(token => {
                            debug('Token changed');
                            const oldToken = this.token;
                            this.token = token;

                            if(!this.socket || this.token !== oldToken) {
                                this._connect();
                            }
                        })
                        .catch(e => {
                            console.error('Get authorization token error: ', e);
                            this._disconnect();
                        });
                }
                else {
                    debug('User disconnected');
                    this._disconnect();
                }
            }, (error) => {
                console.error(error);

                this._disconnect();
            });
        }
    }

    disable() {
        debug('Tis disabled');

        if(this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
        }

        this._disconnect();
    }

    _connect() {
        if(this.socket) {
            this._disconnect();
        }

        debug('Connecting');

        let url;
        if(config.socketPort) {
            url = `${window.location.protocol}//${window.location.hostname}:${config.socketPort}`;
        }

        this.socket = ioClient(url, {
            path: '/mobile',
            query: {
                token: this.token
            }
        });

        this.socket.on('connect', () => {
            debug('Connected to TIS');

            this.socket.on('targetUpdate', (msg) => {
                rtDebug('Target update message: ', msg);

                this.emit('targetUpdate', msg);
            });
        });

        this.socket.on('connect_error', (error) => {
            console.error('Connection to TIS failed', error);
        });
    }

    _disconnect() {
        if(this.socket) {
            debug('Disconnecting');
            this.socket.close();
            this.socket = null;
        }
    }
}

export default new Tis();